module.exports = __webpack_public_path__ + "static/media/trainingBot.1641c228.gif";